// extracted by mini-css-extract-plugin
export default {"arrowLink":"_f2367091","arrow":"_faf44131","arrowFiller":"_177e3969"};